
import { Proforma } from '@app/models';
import { Action } from '@ngrx/store';

interface CreateDTO {
  ProviderId: number;
  PortId: number;
  CountryId: number;
  ShipmentId: number;
  businessUnit: string;
}

interface UpdateDTO { }

export enum ProformaActionTypes {
  Load = '[Proforma] Load',
  LoadSuccess = '[Proforma] Load Success',
  LoadFail = '[Proforma] Load Fail',
  Create = '[Proforma] Create',
  CreateSuccess = '[Proforma] Create Success',
  CreateFail = '[Proforma] Create Fail',
  UpdateShipment = '[Proforma] Update shipment',
  UpdateShipmentSuccess = '[Proforma] Update shipment success',
  Update = '[Proforma] Update',
  UpdateProformaEditSuccess = '[Proforma] Update proforma edit',
  UpdateSuccess = '[Proforma] Update Success',
  UpdateFail = '[Proforma] Update Fail',
  Generate = '[Proforma] Generate',
  GenerateSuccess = '[Proforma] Generate Success',
  GenerateFail = '[Proforma] Generate Fail',

  DeleteAllProforma = '[Proforma] Delete All Proforma',
  DeleteAllProformaSuccess = '[Proforma] Delete All Proforma Success',
  DeleteAllProformaFail = '[Proforma] Delete All Proforma Fail',

  ShipmentUpdateCancel = '[Proforma] Shipment Update Cancel',
  ShipmentUpdateCancelSuccess = '[Proforma] Shipment Update Cancel Success',
  ShipmentUpdateCancelFail = '[Proforma] Shipment Update Cancel Fail',

  UpdateCancel = '[Proforma] Update Cancel',
  UpdateCancelSuccess = '[Proforma] Update Cancel Success',
  UpdateCancelFail = '[Proforma] Update Cancel Fail',

  UpdateGenerate = '[Proforma] Update generate',
  UpdateGenerateSuccess = '[Proforma] Update generate success',
  UpdateGenerateFail = '[Proforma] Update generate fail',

  ExportGroup = '[Proforma] Export group',
  ExportGroupSuccess = '[Proforma] Export group success',
  ExportGroupUpdate = '[Proforma] Export group update',
  ExportGroupFail = '[Proforma] Export group fail',

  ExportGroupDownload = '[Proforma] Export group download',
  ExportGroupDownloadSuccess = '[Proforma] Export group download success',
  ExportGroupDownloadFail = '[Proforma] Export group download fail',

  AddProducts = '[Proforma] Add products to proforma',
  AddProductsSuccess = '[Proforma] Add products to proforma success',
  AddProductsFail = '[Proforma] Add products to proforma failed',

  DeleteProduct = '[Proforma] Delete a product from a proforma',
  DeleteProductSuccess = '[Proforma] Delete a product from a proforma success',
  DeleteProductFail = '[Proforma] Delete a product from a proforma failed',

  Search = '[Search] Search proforma',
  SearchSuccess = '[Search] Search proforma success',
  SearchFail = '[Search] Search proforma fail',
  ClearSearch = '[Search] Clear search proforma',

  Summary = '[Summary] Search proforma',
  SummarySuccess = '[Summary] Search proforma success',

  SearchProduct = '[Search] Search product',
  SearchProductSuccess = '[Search] Search product success',
  SearchProductFail = '[Search] Search product fail',
  SearchClearProduct = '[Search] Clear product ids',

  UpdateStatus = '[Proforma] Update Status',
  UpdateStatusSuccess = '[Proforma] Update Status edit',
  UpdateStatusFail = '[Proforma] Update Status Fail',

  VoidAction = '[VOID] Void action that should not be handled',

  RecalculateWeightedFob = '[Proforma] Recalculate weightedFob',
  RecalculateWeightedFobSuccess = '[Proforma] Recalculate weightedFob success',
  RecalculateWeightedFobFail = '[Proforma] Recalculate weightedFob fail',

  ProcessFile = '[Proforma] Process file',
  ProcessFileSuccess = '[Proforma] Process file success',
  ProcessFileWithSkusSuccess = '[Proforma] Process file with skus success',
  ProcessFileCancel = '[Proforma] Process file cancel',

  ProformasDetailDownloabled = '[Proforma] detail proforma downloabled',
  ProformasDetailDownloabledSuccess = '[Proforma] detail proforma downloabled success',
  ProformasDetailDownloabledFail = '[Proforma] detail proforma downloabled fail',
  EnrichProducts = '[Proforma] Enrich Products',
  EnrichProductsSuccess = '[Proforma] Enrich Products success',
  EnrichProductsFail = '[Proforma] Enrich Products fail',

  AllEnrichProducts = '[Proforma] All Enrich Products',
  AllEnrichProductsSuccess = '[Proforma] All Enrich Products success',
  AllEnrichProductsFail = '[Proforma] All Enrich Products fail',

  AllDepartmentSheets = '[Proforma] all Department Sheets',
  AllDepartmentSheetsSuccess = '[Proforma] all Department Sheets success',
  AllDepartmentSheetsFail = '[Proforma] all Department Sheets fail',

  N2Department = '[Proforma] N2Department',
  N2DepartmentSuccess = '[Proforma] N2Department success',
  N2DepartmentFail = '[Proforma] N2Department fail',

  DownloadEnrichProducts = '[Proforma] Download Enrich Products',
  DownloadEnrichProductsSuccess = '[Proforma] Download Enrich Products success',
  DownloadEnrichProductsFail = '[Proforma] Download Enrich Products fail',

  UploadFile = '[Proforma] Upload Massive Enrich',
  UploadFileSuccess = '[Proforma] Upload Massive Enrich success',
  UploadFileFail = '[Proforma] Upload Massive Enrich fail',

  GetUploadLink = '[Proforma] GetUploadLink',
  GetUploadLinkSuccess = '[Proforma] GetUploadLink success',
  GetUploadLinkFail = '[Proforma] GetUploadLink fail',
  NotifyFileUpload = '[Proforma] Notify file upload',

  UpsertEnrichProducts = '[Proforma] Upsert Enrich Products',
  UpsertEnrichProductsSuccess = '[Proforma] Upsert Enrich Products success',
  UpsertEnrichProductsFail = '[Proforma] Upsert Enrich Products fail',

  MigrateProductsShipments = '[Proforma] Migrate Products Shipments',
  MigrateProductsShipmentsSuccess = '[Proforma] Migrate Products Shipments success',
  MigrateProductsShipmentsFail = '[Proforma] Migrate Products Shipments fail',

  NewProformaProduct = '[Proforma] New Proforma Product',
  NewProformaProductSuccess = '[Proforma] New Proforma Product success',
  NewProformaProductFail = '[Proforma] New Proforma Product fail',

  UpdateOne = '[Proforma] Update one',
  UpdateOneSuccess = '[Proforma] Update one success',
  UpdateOneFail = '[Proforma] Update one fail',

  SupplierFile = '[Proforma] supplier file',
  SupplierFileUpdate = '[Proforma] supplier file update',
  SupplierFileSuccess = '[Proforma] supplier file success',
  SupplierFileFail = '[Proforma] supplier file fail',

  ClearState = '[Proforma] clear state',

  DiscrepanciesWebLoad = '[Proforma] Discrepancies web load',
  DiscrepanciesWebLoadSuccess = '[Proforma] Discrepancies web load success',
  DiscrepanciesWebLoadFail = '[Proforma] Discrepancies web load fail',

  AddDelayProformas = '[Proforma] Add delay proformas',
  AddDelayProformasSuccess = '[Proforma] Add delay proformas success',
  AddDelayProformasFail = '[Proforma] Add delay proformas fail',
}

export class SupplierFile implements Action {
  readonly type = ProformaActionTypes.SupplierFile;
  constructor(public FollowId?: any) { }
}

export class SupplierFileUpdate implements Action {
  readonly type = ProformaActionTypes.SupplierFileUpdate;
  constructor(public FileId: any, public status: any, public FollowId: any, public followType: any) { }
}

export class SupplierFileSuccess implements Action {
  readonly type = ProformaActionTypes.SupplierFileSuccess;
  constructor(public data?: any) { }
}

export class SupplierFileFail implements Action {
  readonly type = ProformaActionTypes.SupplierFileFail;
  constructor(public error?: any) { }
}

export class UpdateOne implements Action {
  readonly type = ProformaActionTypes.UpdateOne;
  constructor(public ProformaId: number, public data?: any) { }
}

export class UpdateOneSuccess implements Action {
  readonly type = ProformaActionTypes.UpdateOneSuccess;
  constructor(public data?: any) { }
}

export class UpdateOneFail implements Action {
  readonly type = ProformaActionTypes.UpdateOneFail;
  constructor(public error?: any) { }
}

export class RecalculateWeightedFob implements Action {
  readonly type = ProformaActionTypes.RecalculateWeightedFob;
  constructor(public ProformaId: number) { }
}

export class RecalculateWeightedFobSuccess implements Action {
  readonly type = ProformaActionTypes.RecalculateWeightedFobSuccess;
  constructor(public data?: any) { }
}

export class RecalculateWeightedFobFail implements Action {
  readonly type = ProformaActionTypes.RecalculateWeightedFobFail;
  constructor(public error?: any) { }
}

export class Load implements Action {
  readonly type = ProformaActionTypes.Load;
  constructor(public FollowId: any, public options?: any) { }
}

export class LoadSuccess implements Action {
  readonly type = ProformaActionTypes.LoadSuccess;
  constructor(public proformas: Proforma[]) { }
}

export class LoadFail implements Action {
  readonly type = ProformaActionTypes.LoadFail;
  constructor(public error: any) { }
}

export class Create implements Action {
  readonly type = ProformaActionTypes.Create;
  constructor(public data: CreateDTO) { }
}

export class CreateSuccess implements Action {
  readonly type = ProformaActionTypes.CreateSuccess;
  constructor(public proforma: Proforma, public data?: any) { }
}

export class CreateFail implements Action {
  readonly type = ProformaActionTypes.CreateFail;
  constructor(public error: any) { }
}

export class UpdateShipment implements Action {
  readonly type = ProformaActionTypes.UpdateShipment;
  constructor(public ProformaId: number, public data: UpdateDTO) { }
}

export class UpdateShipmentSuccess implements Action {
  readonly type = ProformaActionTypes.UpdateShipmentSuccess;
  constructor(public data?: any) { }
}

export class Update implements Action {
  readonly type = ProformaActionTypes.Update;
  constructor(public ProformaId: number, public data: UpdateDTO) { }
}

export class UpdateProformaEditSuccess implements Action {
  readonly type = ProformaActionTypes.UpdateProformaEditSuccess;
  constructor(public data?: any) { }
}

export class UpdateSuccess implements Action {
  readonly type = ProformaActionTypes.UpdateSuccess;
  constructor(public proforma: Proforma, public data?: any) { }
}

export class UpdateFail implements Action {
  readonly type = ProformaActionTypes.UpdateFail;
  constructor(public error: any) { }
}

export class UpdateGenerate implements Action {
  readonly type = ProformaActionTypes.UpdateGenerate;
  constructor(public FollowId: number, public options?: any) { }
}

export class UpdateGenerateSuccess implements Action {
  readonly type = ProformaActionTypes.UpdateGenerateSuccess;
  constructor(public proforma: Proforma[], public data?: any) { }
}

export class UpdateGenerateFail implements Action {
  readonly type = ProformaActionTypes.UpdateGenerateFail;
  constructor(public error: any) { }
}

export class ShipmentUpdateCancel implements Action {
  readonly type = ProformaActionTypes.ShipmentUpdateCancel;
  constructor(public ProformaId: number, public data: UpdateDTO) { }
}

export class ShipmentUpdateCancelSuccess implements Action {
  readonly type = ProformaActionTypes.ShipmentUpdateCancelSuccess;
  constructor(public proforma: Proforma, public data?: any) { }
}

export class ShipmentUpdateCancelFail implements Action {
  readonly type = ProformaActionTypes.ShipmentUpdateCancelFail;
  constructor(public error: any) { }
}

export class UpdateCancel implements Action {
  readonly type = ProformaActionTypes.UpdateCancel;
  constructor(public ProformaId: number, public data: UpdateDTO) { }
}

export class UpdateCancelSuccess implements Action {
  readonly type = ProformaActionTypes.UpdateCancelSuccess;
  constructor(public proforma: any, public data?: any) { }
}

export class UpdateCancelFail implements Action {
  readonly type = ProformaActionTypes.UpdateCancelFail;
  constructor(public error: any) { }
}

export class Generate implements Action {
  readonly type = ProformaActionTypes.Generate;
  constructor(public FollowId: number) { }
}

export class GenerateSuccess implements Action {
  readonly type = ProformaActionTypes.GenerateSuccess;
  constructor(public proformas: Proforma[], public data?: any) { }
}

export class GenerateFail implements Action {
  readonly type = ProformaActionTypes.GenerateFail;
  constructor(public error: any) { }
}

export class DeleteAllProforma implements Action {
  readonly type = ProformaActionTypes.DeleteAllProforma;
  constructor(public FollowId: number) { }
}

export class DeleteAllProformaSuccess implements Action {
  readonly type = ProformaActionTypes.DeleteAllProformaSuccess;
  constructor(public data: any) { }
}

export class DeleteAllProformaFail implements Action {
  readonly type = ProformaActionTypes.DeleteAllProformaFail;
  constructor(public error: any) { }
}

export class ExportGroup implements Action {
  readonly type = ProformaActionTypes.ExportGroup;
  constructor(public data: any) { }
}

export class ExportGroupSuccess implements Action {
  readonly type = ProformaActionTypes.ExportGroupSuccess;
  constructor(public data: any) { }
}

export class ExportGroupUpdate implements Action {
  readonly type = ProformaActionTypes.ExportGroupUpdate;
  constructor(public data: any) { }
}

export class ExportGroupFail implements Action {
  readonly type = ProformaActionTypes.ExportGroupFail;
  constructor(public error: any) { }
}

export class ExportGroupDownload implements Action {
  readonly type = ProformaActionTypes.ExportGroupDownload;
  constructor(public downloadUrl: string, public name: string, public total?: number) { }
}

export class ExportGroupDownloadSuccess implements Action {
  readonly type = ProformaActionTypes.ExportGroupDownloadSuccess;
  constructor() { }
}

export class ExportGroupDownloadFail implements Action {
  readonly type = ProformaActionTypes.ExportGroupDownloadFail;
  constructor(public error: any) { }
}

export class AddProducts implements Action {
  readonly type = ProformaActionTypes.AddProducts;
  constructor(
    public ProformaId: number,
    public FollowId: number,
    public ProductIds: number[],
    public data?: any
  ) { }
}

export class AddProductsSuccess implements Action {
  readonly type = ProformaActionTypes.AddProductsSuccess;
  constructor(public data: any) { }
}

export class AddProductsFail implements Action {
  readonly type = ProformaActionTypes.AddProductsFail;
  constructor(public error: any) { }
}

export class DeleteProduct implements Action {
  readonly type = ProformaActionTypes.DeleteProduct;
  constructor(
    public ProformaId: number,
    public FollowId: number,
    public ProductId: number,
    public ShipmentId?: number,
    public isDiscrepanciesView?: boolean,
    public ParentId?: any,
  ) { }
}

export class DeleteProductSuccess implements Action {
  readonly type = ProformaActionTypes.DeleteProductSuccess;
  constructor(public data: any) { }
}

export class DeleteProductFail implements Action {
  readonly type = ProformaActionTypes.DeleteProductFail;
  constructor(public error: any) { }
}

export class Search implements Action {
  readonly type = ProformaActionTypes.Search;
  constructor(public data: any, public FollowId: any) { }
}

export class SearchSuccess implements Action {
  readonly type = ProformaActionTypes.SearchSuccess;
  constructor(public ProformaIds: any[]) { }
}

export class SearchFail implements Action {
  readonly type = ProformaActionTypes.SearchFail;
  constructor(public error: any) { }
}

export class ClearSearch implements Action {
  readonly type = ProformaActionTypes.ClearSearch;
  constructor() { }
}

export class Summary implements Action {
  readonly type = ProformaActionTypes.Summary;
  constructor(public followId: number) { }
}

export class SummarySuccess implements Action {
  readonly type = ProformaActionTypes.SummarySuccess;
  constructor(public savedSummary: Summary[], public data?: any) { }
}

export class SearchProduct implements Action {
  readonly type = ProformaActionTypes.SearchProduct;
  constructor(public ProformaId: any, public data?: any) { }
}

export class SearchProductSuccess implements Action {
  readonly type = ProformaActionTypes.SearchProductSuccess;
  constructor(public ProductIds: any[], public extraData?: any) { }
}
export class SearchProductFail implements Action {
  readonly type = ProformaActionTypes.SearchProductFail;
  constructor(public error: any) { }
}

export class SearchClearProduct implements Action {
  readonly type = ProformaActionTypes.SearchClearProduct;
  constructor() { }
}

export class VoidAction implements Action {
  readonly type = ProformaActionTypes.VoidAction;
  constructor() { }
}

export class UpdateStatus implements Action {
  readonly type = ProformaActionTypes.UpdateStatus;
  constructor(public FollowId: number, public data?: any ) { }
}

export class UpdateStatusSuccess implements Action {
  readonly type = ProformaActionTypes.UpdateStatusSuccess;
  constructor(public data?: any) { }
}


export class UpdateStatusFail implements Action {
  readonly type = ProformaActionTypes.UpdateStatusFail;
  constructor(public error: any) { }
}

export class ProformasDetailDownloabled implements Action {
  readonly type = ProformaActionTypes.ProformasDetailDownloabled;
  constructor(public data?: any ) { }
}

export class ProformasDetailDownloabledSuccess implements Action {
  readonly type = ProformaActionTypes.ProformasDetailDownloabledSuccess;
  constructor(public data?: any) { }
}

export class ProformasDetailDownloabledFail implements Action {
  readonly type = ProformaActionTypes.ProformasDetailDownloabledFail;
  constructor(public error: any) { }
}

export class ProcessFile implements Action {
  readonly type = ProformaActionTypes.ProcessFile;
  constructor(public data?: any) { }
}

export class ProcessFileSuccess implements Action {
  readonly type = ProformaActionTypes.ProcessFileSuccess;
  constructor(public data: any,) { }
}

export class ProcessFileWithSkusSuccess implements Action {
  readonly type = ProformaActionTypes.ProcessFileWithSkusSuccess;
  constructor() { }
}

export class ProcessFileCancel implements Action {
  readonly type = ProformaActionTypes.ProcessFileCancel;
  constructor() { }
}

export class EnrichProducts implements Action {
  readonly type = ProformaActionTypes.EnrichProducts;
  constructor(public data: any){}
}

export class EnrichProductsSuccess implements Action {
  readonly type = ProformaActionTypes.EnrichProductsSuccess;
  constructor(public data?: any){}
}

export class EnrichProductsFail implements Action {
  readonly type = ProformaActionTypes.EnrichProductsFail;
  constructor(public error?: any){}
}

export class AllEnrichProducts implements Action {
  readonly type = ProformaActionTypes.AllEnrichProducts;
  constructor(public data?: any){}
}

export class AllEnrichProductsSuccess implements Action {
  readonly type = ProformaActionTypes.AllEnrichProductsSuccess;
  constructor(public data?: any){}
}

export class AllEnrichProductsFail implements Action {
  readonly type = ProformaActionTypes.AllEnrichProductsFail;
  constructor(public error?: any){}
}

export class AllDepartmentSheets implements Action {
  readonly type = ProformaActionTypes.AllDepartmentSheets;
  constructor(){}
}

export class AllDepartmentSheetsSuccess implements Action {
  readonly type = ProformaActionTypes.AllDepartmentSheetsSuccess;
  constructor(public data: any){}
}

export class AllDepartmentSheetsFail implements Action {
  readonly type = ProformaActionTypes.AllDepartmentSheetsFail;
  constructor(public error?: any){}
}

export class N2Department implements Action {
  readonly type = ProformaActionTypes.N2Department;
  constructor(){}
}

export class N2DepartmentSuccess implements Action {
  readonly type = ProformaActionTypes.N2DepartmentSuccess;
  constructor(public data: any){}
}

export class N2DepartmentFail implements Action {
  readonly type = ProformaActionTypes.N2DepartmentFail;
  constructor(public error?: any){}
}

export class DownloadEnrichProducts implements Action {
  readonly type = ProformaActionTypes.DownloadEnrichProducts;
  constructor(public data?: any) {}
}

export class DownloadEnrichProductsSuccess implements Action {
  readonly type = ProformaActionTypes.DownloadEnrichProductsSuccess;
  constructor(public data?: any) {}
}

export class DownloadEnrichProductsFail implements Action {
  readonly type = ProformaActionTypes.DownloadEnrichProductsFail;
  constructor(public error?: any) {}
}

export class UpsertEnrichProducts implements Action {
  readonly type = ProformaActionTypes.UpsertEnrichProducts;
  constructor(public data?: any, public supplierId?: any) {}
}

export class UpsertEnrichProductsSuccess implements Action {
  readonly type = ProformaActionTypes.UpsertEnrichProductsSuccess;
  constructor(public data?: any, public supplierId?: any) {}
}

export class UpsertEnrichProductsFail implements Action {
  readonly type = ProformaActionTypes.UpsertEnrichProductsFail;
  constructor(public error?: any) {}
}

export class UploadFile implements Action {
  readonly type = ProformaActionTypes.UploadFile;
  constructor(public link: string,
    public file: any,
    public uploadType: any,
    public data?: any) {}
}

export class UploadFileSuccess implements Action {
  readonly type = ProformaActionTypes.UploadFileSuccess;
  constructor(public uploadType?: any) {}
}

export class UploadFileFail implements Action {
  readonly type = ProformaActionTypes.UploadFileFail;
  constructor(public error?: any) {}
}

export class GetUploadLink implements Action {
  readonly type = ProformaActionTypes.GetUploadLink;
  constructor(public file: any, public uploadType: any, public data?: any) { }
}

export class GetUploadLinkFail implements Action {
  readonly type = ProformaActionTypes.GetUploadLinkFail;
  constructor(public error: any) { }
}

export class GetUploadLinkSuccess implements Action {
  readonly type = ProformaActionTypes.GetUploadLinkSuccess;
  constructor(public link: string, public file: any, public uploadType?: any) { }
}

export class NotifyFileUpload implements Action {
  readonly type = ProformaActionTypes.NotifyFileUpload;
  constructor(public id: string, public uploadType?: any) { }
}

export class MigrateProductsShipments implements Action {
  readonly type = ProformaActionTypes.MigrateProductsShipments;
  constructor(public proformaId: number, public shipmentId: number, public pcsId: any) {}
}

export class MigrateProductsShipmentsSuccess implements Action {
  readonly type = ProformaActionTypes.MigrateProductsShipmentsSuccess;
  constructor(public data: any) {}
}

export class MigrateProductsShipmentsFail implements Action {
  readonly type = ProformaActionTypes.MigrateProductsShipmentsFail;
  constructor(public error: any) {}
}

export class NewProformaProduct implements Action {
  readonly type = ProformaActionTypes.NewProformaProduct;
  constructor(public shipmentId: any, public selectedProductIds: any, public providerId: any, public udnCountry: any) {}
}

export class NewProformaProductSuccess implements Action {
  readonly type = ProformaActionTypes.NewProformaProductSuccess;
  constructor(public data?: any) {}
}

export class NewProformaProductFail implements Action {
  readonly type = ProformaActionTypes.NewProformaProductFail;
  constructor(public error?: any) {}
}

export class DiscrepanciesWebLoad implements Action {
  readonly type = ProformaActionTypes.DiscrepanciesWebLoad;
  constructor(public message: string) {}
}

export class DiscrepanciesWebLoadSuccess implements Action {
  readonly type = ProformaActionTypes.DiscrepanciesWebLoadSuccess;
  constructor(public data?: any) {}
}

export class DiscrepanciesWebLoadFail implements Action {
  readonly type = ProformaActionTypes.DiscrepanciesWebLoadFail;
  constructor(public error?: any) {}
}

export class AddDelayProformas implements Action {
  readonly type = ProformaActionTypes.AddDelayProformas;
  constructor(public data: any) {}
}

export class AddDelayProformasSuccess implements Action {
  readonly type = ProformaActionTypes.AddDelayProformasSuccess;
  constructor(public data?: any) {}
}

export class AddDelayProformasFail implements Action {
  readonly type = ProformaActionTypes.AddDelayProformasFail;
  constructor(public error?: any) {}
}

export class ClearState implements Action {
  readonly type = ProformaActionTypes.ClearState;
  constructor(){}
}

export type ProformaActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | Create
  | CreateSuccess
  | CreateFail
  | Update
  | UpdateProformaEditSuccess
  | UpdateSuccess
  | UpdateFail
  | UpdateCancel
  | UpdateCancelSuccess
  | UpdateCancelFail
  | Generate
  | GenerateSuccess
  | GenerateFail
  | UpdateGenerate
  | UpdateGenerateSuccess
  | UpdateGenerateFail
  | ExportGroup
  | ExportGroupSuccess
  | ExportGroupUpdate
  | ExportGroupFail
  | ExportGroupDownload
  | ExportGroupDownloadSuccess
  | ExportGroupDownloadFail
  | AddProducts
  | AddProductsSuccess
  | AddProductsFail
  | DeleteProduct
  | DeleteProductSuccess
  | DeleteProductFail
  | DeleteAllProforma
  | DeleteAllProformaSuccess
  | DeleteAllProformaFail
  | Search
  | SearchSuccess
  | SearchFail
  | ClearSearch
  | Summary
  | SummarySuccess
  | SearchProduct
  | SearchProductSuccess
  | SearchProductFail
  | SearchClearProduct
  | VoidAction
  | UpdateStatus
  | UpdateStatusSuccess
  | UpdateStatusFail
  | RecalculateWeightedFob
  | RecalculateWeightedFobSuccess
  | RecalculateWeightedFobFail
  | ShipmentUpdateCancel
  | ShipmentUpdateCancelSuccess
  | ShipmentUpdateCancelFail
  | UpdateShipment
  | UpdateShipmentSuccess
  | ProcessFile
  | ProcessFileSuccess
  | ProcessFileCancel
  | ProcessFileWithSkusSuccess
  | ProformasDetailDownloabled
  | ProformasDetailDownloabledSuccess
  | ProformasDetailDownloabledFail
  | EnrichProducts
  | EnrichProductsSuccess
  | EnrichProductsFail
  | AllEnrichProducts
  | AllEnrichProductsSuccess
  | AllEnrichProductsFail
  | AllDepartmentSheets
  | AllDepartmentSheetsSuccess
  | AllDepartmentSheetsFail
  | N2Department
  | N2DepartmentSuccess
  | N2DepartmentFail
  | DownloadEnrichProducts
  | DownloadEnrichProductsSuccess
  | DownloadEnrichProductsFail
  | UploadFile
  | UploadFileSuccess
  | UploadFileFail
  | GetUploadLink
  | GetUploadLinkSuccess
  | GetUploadLinkFail
  | NotifyFileUpload
  | UpsertEnrichProducts
  | UpsertEnrichProductsSuccess
  | UpsertEnrichProductsFail
  | ClearState
  | MigrateProductsShipments
  | MigrateProductsShipmentsSuccess
  | MigrateProductsShipmentsFail
  | NewProformaProduct
  | NewProformaProductSuccess
  | NewProformaProductFail
  | UpdateOne
  | UpdateOneSuccess
  | UpdateOneFail
  | SupplierFile
  | SupplierFileUpdate
  | SupplierFileSuccess
  | SupplierFileFail
  | DiscrepanciesWebLoad
  | DiscrepanciesWebLoadSuccess
  | DiscrepanciesWebLoadFail
  | AddDelayProformas
  | AddDelayProformasSuccess
  | AddDelayProformasFail;
